import styled from "@emotion/styled";

export const ToAddressDiv = styled.div`
  margin-top: 30px;
  margin-bottom: 10px;
  color: #b2b2b2;
  font-size: 10px;
  line-height: 22px;
`;
